module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/25/assets/images/0051cf8cd3f561be71953b279b9a3c76.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_attempt.svg
// module id = 675q
// module chunks = 0